module.exports = __webpack_public_path__ + "images/inbox/google-logomark.png";